import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ContainerSection } from '@components/_global/GlobalStyle/Global.styled';
import { Unavailable } from '@components/_universal/Survey/Unavailable/Unavailable';
import { FeedbackLayout } from '@components/templates/FeedbackLayout/FeedbackLayout';

import { getPath } from '@services/RouteService/paths';

export const SurveyUnavailablePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <FeedbackLayout
            iconProps={{
                icon: 'SvgUnavailable',
                size: 86,
            }}
        >
            <ContainerSection>
                <Unavailable
                    buttonOnPress={() =>
                        navigate(getPath({ path: '/survey/list' }))
                    }
                    buttonText={t('SURVEY_BACK_TO_LIST_BUTTON')}
                    description={t('SURVEY_UNAVAILABLE_DESCRIPTION')}
                    title={t('UNAVAILABLE_TITLE')}
                />
            </ContainerSection>
        </FeedbackLayout>
    );
};
